module.exports = __webpack_public_path__ + "img/Streeme-login.83f76f.svg";